import React from 'react'
import { useLocation } from 'react-router-dom';
import Note from 'components/StraightThroughAddressComp/Note/Note';
import AddressChangeBtnNav from 'components/StraightThroughAddressComp/AddressChangeBtnNav/AddressChangeBtnNav';
import HouseholdChangeBtnNav from './HouseholdChangeBtnNav/HouseholdChangeBtnNav';
import { DriverHHMContextComp } from './HouseholdContext/DriverHHMContext';
import StraightThrough_OnPolicyInput from './StraightThrough_OnPolicyInput';

const StraightThrough_HouseholdMain = () => {
    const location = useLocation()

    return (
        <>
            <DriverHHMContextComp>
                <StraightThrough_OnPolicyInput />
                
                <hr />
                <Note />
                <hr />

                {/* Navigation Buttons */}
                {location.pathname.includes("address")
                    ? <AddressChangeBtnNav />
                    : <HouseholdChangeBtnNav />
                }
            </DriverHHMContextComp>
        </>
    )
}

export default StraightThrough_HouseholdMain